// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format7 } from '../../constants';

/** Paraguay */
const PY: PhoneNumberData = [595, 'PY', 9, format7];

export default PY;
